// src/pages/Accounting/Receipts/mockData.ts

import type { Receipt } from "./types";

export const mockReceiptsEmpty: Receipt[] = [];

export const mockReceiptsPopulated: Receipt[] = [
  {
    id: "rc_01",
    vendorName: "Shell gas station",
    date: "2026-10-13",
    total: 62.80,
    tax: { gst: 2.99 },
    currency: "CAD",
    source: "mobile",
    matchStatus: "matched",
    matchedTransactionId: "tx_05",
    uploadedAt: "2026-10-13T14:12:00Z",
  },
  {
    id: "rc_02",
    vendorName: "Grand & Toy",
    date: "2026-10-12",
    total: 142.80,
    tax: { hst: 16.52 },
    currency: "CAD",
    source: "email",
    matchStatus: "matched",
    matchedTransactionId: "tx_07",
    uploadedAt: "2026-10-12T09:30:00Z",
  },
  {
    id: "rc_03",
    vendorName: "Unclear vendor",
    date: "2026-10-10",
    total: 485.00,
    tax: {},
    currency: "CAD",
    source: "upload",
    matchStatus: "needs-review",
    uploadedAt: "2026-10-10T18:04:00Z",
  },
  {
    id: "rc_04",
    vendorName: "Starbucks",
    date: "2026-10-09",
    total: 8.75,
    tax: { gst: 0.42 },
    currency: "CAD",
    source: "mobile",
    matchStatus: "matched",
    matchedTransactionId: "tx_sb01",
    uploadedAt: "2026-10-09T11:20:00Z",
  },
  {
    id: "rc_05",
    vendorName: "Amazon",
    date: "2026-10-08",
    total: 94.20,
    tax: { gst: 4.48 },
    currency: "CAD",
    source: "email",
    matchStatus: "needs-review",
    matchedTransactionId: "tx_amz01",
    uploadedAt: "2026-10-08T22:40:00Z",
  },
  {
    id: "rc_06",
    vendorName: "Uber Canada",
    date: "2026-10-07",
    total: 23.95,
    tax: { gst: 1.14 },
    currency: "CAD",
    source: "email",
    matchStatus: "matched",
    matchedTransactionId: "tx_ub01",
    uploadedAt: "2026-10-07T19:00:00Z",
  },
  {
    id: "rc_07",
    vendorName: "Costco Wholesale",
    date: "2026-10-05",
    total: 171.30,
    tax: { hst: 19.84 },
    currency: "CAD",
    source: "upload",
    matchStatus: "matched",
    matchedTransactionId: "tx_cst01",
    uploadedAt: "2026-10-05T15:00:00Z",
  },
  {
    id: "rc_08",
    vendorName: "Petro-Canada",
    date: "2026-10-03",
    total: 48.20,
    tax: { gst: 2.30 },
    currency: "CAD",
    source: "mobile",
    matchStatus: "needs-review",
    uploadedAt: "2026-10-03T08:15:00Z",
  },
];
